import { RemixBrowser } from "@remix-run/react"
import { startTransition, StrictMode } from "react"
import { hydrateRoot } from "react-dom/client"
import { SentryMonitoring } from "./shared/sentry-monitoring.tsx"

if (window.SENTRY_CONFIG) {
  SentryMonitoring.init(window.SENTRY_CONFIG)
}

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <RemixBrowser />
    </StrictMode>,
  )
})
